
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.283 7.315l-8.762-3.271a.499.499 0 00-.409 0L5.41 7.314A.561.561 0 005 7.842v7.652c0 6.834 8.704 11.273 9.054 11.449.058.058.175.058.234.058.058 0 .175 0 .233-.058.468-.176 9.171-4.615 9.171-11.45V7.842a.561.561 0 00-.409-.526z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.5 10a5.5 5.5 0 100 11 5.5 5.5 0 000-11z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.03 15.456a.296.296 0 00-.104-.111.28.28 0 00-.143-.042h-.165a.173.173 0 01-.14-.067.185.185 0 01-.044-.152 3.3 3.3 0 01.731-1.702 3.08 3.08 0 011.51-.996 2.966 2.966 0 011.785.042 3.096 3.096 0 011.465 1.066.366.366 0 00.482.008.407.407 0 00.092-.494 3.842 3.842 0 00-1.852-1.324 3.685 3.685 0 00-2.244-.018 3.835 3.835 0 00-1.87 1.295 4.11 4.11 0 00-.86 2.166.199.199 0 01-.06.124.183.183 0 01-.124.052h-.206c-.05 0-.1.013-.143.04a.287.287 0 00-.104.111.303.303 0 00.007.3l.75 1.253a.29.29 0 00.103.1.276.276 0 00.377-.1l.75-1.254a.308.308 0 00.007-.297zM18.957 15.244l-.75-1.253a.287.287 0 00-.48 0l-.75 1.253a.302.302 0 00.097.41c.043.027.093.041.143.04h.165a.173.173 0 01.14.067.187.187 0 01.044.153 3.3 3.3 0 01-.731 1.702c-.399.48-.924.826-1.51.996a2.966 2.966 0 01-1.785-.042 3.095 3.095 0 01-1.465-1.066.366.366 0 00-.482-.009.407.407 0 00-.092.494 3.843 3.843 0 001.848 1.325c.728.24 1.508.248 2.24.023a3.833 3.833 0 001.872-1.287 4.11 4.11 0 00.866-2.16.2.2 0 01.06-.124.183.183 0 01.124-.052h.206c.05 0 .1-.013.143-.04a.29.29 0 00.105-.11.304.304 0 00-.008-.3v-.02z","fill":"currentColor"}})])
          )
        }
      }
    